


























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { HeartbeatDto } from '@/shared/dtos/agents-admin';

@Component
export default class HeartbeatsTab extends Vue {
    @Prop() public heartbeats: HeartbeatDto[] = [];
    @Prop() public loading: boolean = false;

    get sortedHeartbeats(): HeartbeatDto[] {
        return [...this.heartbeats].sort((a, b) => {
            const dateA = a.received_at_utc ? new Date(a.received_at_utc).getTime() : 0;
            const dateB = b.received_at_utc ? new Date(b.received_at_utc).getTime() : 0;
            return dateB - dateA;
        });
    }

    get heartbeatsByAgent(): { [key: string]: HeartbeatDto[] } {
        const grouped: { [key: string]: HeartbeatDto[] } = {};
        this.sortedHeartbeats.forEach(hb => {
            const agentId = hb.agent_id || 'Sin agente';
            if (!grouped[agentId]) {
                grouped[agentId] = [];
            }
            grouped[agentId].push(hb);
        });
        return grouped;
    }

    get groupedAgents(): string[] {
        return Object.keys(this.heartbeatsByAgent).sort();
    }

    public getHealthClass(status: number): string {
        switch (status) {
            case 1: return 'health-healthy';
            case 2: return 'health-warning';
            case 3: return 'health-error';
            default: return 'health-unknown';
        }
    }

    public getHealthText(status: number): string {
        switch (status) {
            case 1: return 'Saludable';
            case 2: return 'Advertencia';
            case 3: return 'Error';
            default: return 'Desconocido';
        }
    }

    public formatDiskSize(mb: number): string {
        const gb = mb / 1024;
        if (gb >= 1) return `${gb.toFixed(1)} GB`;
        return `${mb} MB`;
    }

    public calculateUptime(startDate: Date | null): string {
        if (!startDate) return 'N/A';
        const now = new Date().getTime();
        const start = new Date(startDate).getTime();
        const diff = Math.floor((now - start) / 1000);

        const days = Math.floor(diff / 86400);
        const hours = Math.floor((diff % 86400) / 3600);
        const mins = Math.floor((diff % 3600) / 60);

        if (days > 0) return `${days}d ${hours}h`;
        if (hours > 0) return `${hours}h ${mins}m`;
        return `${mins}m`;
    }

    public formatDate(date: Date | string | null): string {
        if (!date) return 'N/A';
        const d = new Date(date);
        return d.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
}
